
const TwitterIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
            <path d="M11.026 0H13.1727L8.48285 5.50697L14 13H9.67983L6.29632 8.45583L2.42427 13H0.276362L5.29249 7.11022L0 0H4.42953L7.48794 4.15404L11.026 0ZM10.2724 11.68H11.4622L3.78349 1.25097H2.50688L10.2724 11.68Z" fill="black" />
        </svg>
    )
}

export default TwitterIcon